import React, { PropsWithChildren, useState } from 'react';
import IconDropDown from 'assets/icons/IconDropDown';
import Column from 'components/common/Column';
import Row from 'components/common/Row';
import Text from 'components/common/Text';

interface Props extends PropsWithChildren {
  title: string;
  isRequired?: string;
}

const DropdownForm = ({ title, isRequired, children }: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const handleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <Column gap="24px" align="flex-start">
      <Row
        justifyContent="space-between"
        style={{ width: '100%', cursor: 'pointer' }}
        onClick={handleExpanded}
      >
        <Row gap="8px">
          <Text color="#414B56" size="20px" weight={500}>
            {title}
          </Text>
        </Row>
        <Row style={{ cursor: 'pointer' }} onClick={handleExpanded}>
          <IconDropDown
            color="#989BA2"
            width="24px"
            height="24px"
            style={{
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </Row>
      </Row>
      {expanded && (
        <Column align="flex-start" gap="32px" style={{ padding: '0 20px' }}>
          {children}
        </Column>
      )}
    </Column>
  );
};

export default DropdownForm;
